import React from 'react';
import { cn } from '../classname';
import { ReactRendererComponent } from '../extensions';
import { logger } from '../logger';
import { useRenderTime } from '../react-utils/hooks';
import { MarkupEditorComponent } from './MarkupEditorComponent';
import { ToolbarView } from './ToolbarView';
import { MarkupToolbarContextProvider } from './toolbar/markup/context';
import './MarkupEditorView.css';
const b = cn('markup-editor');
export const MarkupEditorView = React.memo((props) => {
    const { editor, autofocus, settingsVisible, toolbarVisible, toolbarConfig, hiddenActionsConfig, className, toolbarClassName, children, stickyToolbar = true, } = props;
    useRenderTime((time) => {
        logger.metrics({
            component: 'markup-editor',
            event: 'render',
            duration: time,
        });
    });
    return (React.createElement("div", { className: b({ toolbar: toolbarVisible }, [className]) },
        toolbarVisible ? (React.createElement(MarkupToolbarContextProvider, { value: {
                uploadHandler: editor.fileUploadHandler,
                needToSetDimensionsForUploadedImages: editor.needToSetDimensionsForUploadedImages,
            } },
            React.createElement(ToolbarView, { editor: editor, editorType: "markup", toolbarEditor: editor, hiddenActionsConfig: hiddenActionsConfig, stickyToolbar: stickyToolbar, toolbarConfig: toolbarConfig, toolbarFocus: () => editor.focus(), settingsVisible: settingsVisible, className: b('toolbar', [toolbarClassName]) }, children))) : null,
        React.createElement(MarkupEditorComponent, { autofocus: autofocus, editor: editor, className: b('editor', { 'toolbar-visible': toolbarVisible }) },
            React.createElement(ReactRendererComponent, { storage: editor.renderStorage }))));
});
MarkupEditorView.displayName = 'YfmMarkupEditorView';
